import {
  ModelConceptRelationship,
  RelationshipMapping,
} from 'src/containers/ProjectDiagram/types/data';
import { Model } from 'src/containers/ProjectDiagram/types/model';
import {
  isMapping,
  isModelConceptRelationship,
  isModelConceptRelationshipLabel,
  isRelationshipMapping,
} from 'src/containers/ProjectDiagram/utils/data';
import { removeDescriptionForIri } from 'src/containers/ProjectDiagram/utils/descriptions';
import { removeLabelForIri } from 'src/containers/ProjectDiagram/utils/labels';
import { removeRelationshipMapping } from 'src/containers/ProjectDiagram/utils/mapping/removeRelationshipMapping';
import { getModelConceptClassValue } from 'src/containers/ProjectDiagram/utils/modelConceptClass/createModelConceptClass';
import { getLabelKeyFromRelationshipKey } from 'src/containers/ProjectDiagram/utils/modelConceptRelationship/createModelConceptRelationshipLabel';
import { removeProjectModelIri } from 'src/containers/ProjectDiagram/utils/projectModelIds';
import { removePropertyType } from 'src/containers/ProjectDiagram/utils/propertyType/removePropertyType';

// use useRemoveModelConceptRelationship() since it also
// clears the diagram and closes drawers if necessary
export const removeModelConceptRelationship =
  (data: ModelConceptRelationship, removeAll?: boolean) => (model: Model) => {
    if (removeAll || (data.to && data.from)) {
      const existingRelationships = model.linkDataArray.filter(
        (link) => isModelConceptRelationship(link) && link.value === data.value
      ) as ModelConceptRelationship[];
      // do not mutate linkDataArray while iterating through linkDataArray
      existingRelationships.forEach((existingRelationship) => {
        removeModelConceptRelationshipInstance(existingRelationship)(model);
      });
    } else {
      removeModelConceptRelationshipInstance(data)(model);
    }

    const hasRemainingLinks = model.linkDataArray.some(
      (link) => isModelConceptRelationship(link) && link.value === data.value
    );
    if (!hasRemainingLinks) {
      removeDescriptionForIri(data.value)(model);
      removeLabelForIri(data.value)(model);
      removeProjectModelIri(data.value)(model);
      removePropertyType(data.value)(model);
    }
  };

export const removeModelConceptRelationshipInstance =
  (data: ModelConceptRelationship) => (model: Model) => {
    model.removeLinkData(data);

    const labelKey = getLabelKeyFromRelationshipKey(data.key);
    const labelData = model.nodeDataArray.find(
      (nodeData) =>
        isModelConceptRelationshipLabel(nodeData) && nodeData.key === labelKey
    );
    if (labelData) {
      model.removeNodeData(labelData);
    }

    const linkDataToRemove: RelationshipMapping[] = [];
    model.linkDataArray.forEach((linkData) => {
      if (
        isRelationshipMapping(linkData) &&
        linkData.relationshipIri === data.value
      ) {
        const sourceClassMapping = model.linkDataArray.find(
          (linkDataB) => isMapping(linkDataB) && linkDataB.key === linkData.from
        );
        if (
          data.from &&
          (sourceClassMapping?.to === data.from ||
            linkData.fromClassIri === getModelConceptClassValue(data.from))
        ) {
          linkDataToRemove.push(linkData);
        }

        const targetClassMapping = model.linkDataArray.find(
          (linkDataB) => isMapping(linkDataB) && linkDataB.key === linkData.to
        );
        if (
          data.to &&
          (targetClassMapping?.to === data.to ||
            linkData.toClassIri === getModelConceptClassValue(data.to))
        ) {
          linkDataToRemove.push(linkData);
        }
      }
    });
    // do not mutate linkDataArray while iterating through linkDataArray
    linkDataToRemove.forEach((linkData) =>
      removeRelationshipMapping(linkData)(model)
    );
  };
